import { Button } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  deleteYoutubeFolderByIdFn,
  getYoutubeFolderFn,
} from "../../Services/Youtube";

const YoutubeFolder = () => {
  const navigate = useNavigate();

  const { data: getYoutubeFolder, refetch } = useQuery({
    queryKey: ["get-youtube-folder"],
    queryFn: getYoutubeFolderFn,
  });

  const { mutate: deleteFolder } = useMutation(deleteYoutubeFolderByIdFn, {
    onSuccess: () => {
      refetch();
      toast.success("YouTube Folder deleted successfully.");
    },
  });

  const handleDelete = (id) => {
    const formData = new FormData();
    formData.append("video_id", id);
    deleteFolder(formData);
  };

  return (
    <>
      {/* Heading */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        YouTube Folder
      </p>

      {/* Add Button */}
      <div className="flex justify-end w-full px-2">
        <NavLink to="/youtube-folder/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-2 py-1">
        {getYoutubeFolder?.data?.data?.map((item) => (
          <div
            key={item.id}
            onClick={() =>
              navigate("/youtube-links", {
                state: {
                  video_id: item.id,
                  title: item.title,
                },
              })
            }
            className="flex flex-col justify-between p-3 border border-gray-300 rounded shadow hover:shadow-lg transition cursor-pointer bg-white"
          >
            {/* Content */}
            <div className="flex flex-col gap-3">
              <p className="text-lg font-semibold text-black">{item.title}</p>

              {item?.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-32 object-cover rounded"
                />
              )}
            </div>

            {/* Actions */}
            <div className="flex justify-center gap-3 pt-4">
              <Button
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/youtube-folder/update", {
                    state: item.id,
                  });
                }}
              >
                Update
              </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(item.id);
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default YoutubeFolder;
